export const PRIV_KET_MAIN =
  "L1hS7eLZ2c" + "RbCGekuUu4ihJ9" + "TzdHiGdUF2XM" + "1jb1iXr2XSzwKNCB";
export const PRIV_KEY_TEST =
  "cTEDmCgszR" + "9676mBHiCtHzci" + "1Xdf5k56nLyV" + "QNswcpxep8zjSRvi";
export const PRIV_KEY_FAKE =
  "KzFfucTYeT" + "Sw7SL99cGnyWB9" + "2n3WzKqmL6Aw" + "puUtQQrG3mKuoaLq";
